<template lang="pug">
  #challenge-builder-controls
    .buttons.is-pulled-left
      WtButton(
        v-if="showCancel"
        is-text
        size="medium"
        color="lightgrey"
        bold
        @click.native="cancel"
      ) CANCEL
      WtButton(
        v-else
        is-text
        color="lightgrey"
        size="medium"
        bold
        @click.native="backAStep"
      ) BACK
      //- button to handle logic for controlling if user can navigate to next step
      WtButton.next-button(
        v-if="!allowNext"
        :disabled="!allowNext"
        :class="[pendoClass, { 'next-button-disabled': !allowNext }]"
        size="large"
        bold
        type="submit"
        @click.native="beforeNext"
      ) {{ activeButtonText }}
      //- allow user to navigate to next step or submit form if it is last step
      WtButton.next-button(
        v-else
        :class="[ pendoClass ]"
        color="primary"
        size="large"
        bold
        :disabled="submitClicked"
        :loading="submitClicked"
        @click.native="triggerAction"
      ) {{ activeButtonText }}
</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ChallengeBuilderControls",

  components: { WtButton },

  props: {
    stepToActivate: {
      type: Number,
      default: 2
    },

    /**
     * Function to call before next step
     */
    beforeNext: {
      type: Function,
      default: () => {}
    },

    allowNext: {
      type: Boolean,
      default: true
    },

    showCancel: {
      type: Boolean,
      default: false
    },

    /**
     * enables submit button for challenge creation
     */
    lastStep: {
      type: Boolean,
      default: false
    },

    buttonText: {
      type: String,
      default: ""
    },

    submitClicked: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters("challengeBuilder", ["activeStep"]),

    activeButtonText() {
      let text = "NEXT";
      text = this.lastStep ? "SUBMIT" : text;
      text = this.buttonText || text;

      return text;
    },

    isAdminSuperComponent() {
      return this.$route.name === "AdminSuperChallengeCenterBuilder";
    },

    isAdminBuilder() {
      return /admin/.test(this.$route.path);
    },

    pendoClass() {
      const adminPendoClasses = [
        "pendo-admin-challenge-builder-step1-next",
        "pendo-admin-challenge-builder-step2-next",
        "pendo-admin-challenge-builder-step3-next",
        "pendo-admin-challenge-builder-step4-submit"
      ];
      const memberPendoClasses = [
        "pendo-member-challenge-builder-step1-next",
        "pendo-member-challenge-builder-step2-next",
        "pendo-member-challenge-builder-step3-next",
        "pendo-member-challenge-builder-step4-submit"
      ];
      const step = this.lastStep ? 3 : this.stepToActivate - 2;

      return this.isAdminBuilder
        ? adminPendoClasses[step]
        : memberPendoClasses[step];
    }
  },

  methods: {
    ...mapActions("challengeBuilder", ["updateActiveStep", "resetForm"]),

    nextStep() {
      this.updateActiveStep(this.stepToActivate);
    },

    backAStep() {
      this.updateActiveStep(this.activeStep - 1);
    },

    triggerAction() {
      if (this.lastStep) {
        this.$emit("submit");
      } else {
        this.nextStep();
      }
    },

    cancel() {
      let name = "Challenges";

      if (this.isAdminBuilder) {
        name = this.isAdminSuperComponent
          ? "AdminSuperChallengeCenterSettings"
          : "ChallengeCenterSettings";
      }

      this.resetForm();

      return this.$router.push({ name });
    }
  }
};
</script>

<style lang="sass" scoped>
#challenge-builder-controls
  margin-right: 1rem
  margin-top: 1rem
  .next-button-disabled
    background: $grey-light !important
</style>
